import React from "react";
import { StyledTh } from "src/styled";

import styles from "./TriangleHeader.module.scss";

export const TriangleHeaderTh: React.FC<
  React.ComponentProps<typeof StyledTh>
> = ({ className, ...props }) => (
  <StyledTh
    className={`${styles.triangleHeaderTh} ${className ?? ""}`}
    {...props}
  />
);
